import { render, staticRenderFns } from "./CompleteTournamentMiniBlock.vue?vue&type=template&id=43bd3304&scoped=true"
import script from "./CompleteTournamentMiniBlock.vue?vue&type=script&lang=js"
export * from "./CompleteTournamentMiniBlock.vue?vue&type=script&lang=js"
import style0 from "./CompleteTournamentMiniBlock.vue?vue&type=style&index=0&id=43bd3304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bd3304",
  null
  
)

export default component.exports